import React from "react";
import { Row, Col, Card, CardBody, Input } from "reactstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useCustomerStates } from "../hooks/useCustomerStates";
import CustomerStateTable from "./CustomerStateTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import CustomerStateFormModal from "./CustomerStateFormModal";
import StateTransitionsConfigurator from "./StateTransitionsConfigurator";

// Spinner component matching standard in the codebase
const Spinner = ({ isLoading }: { isLoading: boolean }) => (
    isLoading ? (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 9999,
            }}
        >
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    ) : null
);

export const CustomerStatesView: React.FC = () => {
    const {
        list,
        allStates,
        total,
        isLoading,
        isFetching,
        searchQuery,
        modalOpen,
        selectedState,
        deactivateModalOpen,
        transitionsModalOpen,
        stateForTransitions,
        isAdmin,
        handleSearch,
        handlePageChange,
        handleEdit,
        handleDeactivate,
        handleConfigureTransitions,
        handleDeactivateConfirm,
        handleModalSubmit,
        setModalOpen,
        setSelectedState,
        setDeactivateModalOpen,
        setStateToDeactivate,
        setTransitionsModalOpen
    } = useCustomerStates();

    return (
        <React.Fragment>
            <Spinner isLoading={isLoading} />

            <div>
                <Row>
                    <Col>
                        <Card>
                            <div className="d-flex align-items-center mt-4 mb-2">
                                <h5 className="card-title mb-0 flex-grow-1 text-center fw-bold">
                                    ESTADOS DE CLIENTES
                                </h5>
                            </div>
                            <CardBody>
                                <Row>
                                    <Col>
                                        <Row className="mb-3 justify-content-between">
                                            <Col xs={12} sm="auto" className="mb-2">
                                                <div className="search-box">
                                                    <Input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder="Buscar por nombre..."
                                                        value={searchQuery}
                                                        onChange={(e) => handleSearch(e.target.value)}
                                                    />
                                                    <i className="ri-search-line search-icon"></i>
                                                </div>
                                            </Col>
                                            {isAdmin && (
                                                <Col xs={12} sm="auto" className="mb-2">
                                                    <button
                                                        className="btn btn-primary add-btn"
                                                        onClick={() => {
                                                            setSelectedState(null);
                                                            setModalOpen(true);
                                                        }}
                                                        disabled={isLoading}
                                                    >
                                                        <i className="ri-add-line align-bottom me-1"></i>{" "}
                                                        Agregar Estado
                                                    </button>
                                                </Col>
                                            )}
                                        </Row>

                                        <div className="card-body px-0">
                                            <CustomerStateTable
                                                data={list}
                                                total={total}
                                                onPageChange={handlePageChange}
                                                isLoading={isFetching}
                                                onEdit={handleEdit}
                                                onDeactivate={handleDeactivate}
                                                onTransitions={handleConfigureTransitions}
                                            />
                                            <ToastContainer closeButton={false} limit={1} />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>

            <CustomerStateFormModal
                isOpen={modalOpen}
                onClose={() => {
                    setModalOpen(false);
                    setSelectedState(null);
                }}
                onSubmit={handleModalSubmit}
                initialData={selectedState}
            />

            <DeleteModal
                show={deactivateModalOpen}
                onDeleteClick={handleDeactivateConfirm}
                onCloseClick={() => {
                    setDeactivateModalOpen(false);
                    setStateToDeactivate(null);
                }}
                loading={isLoading}
            />

            <StateTransitionsConfigurator
                isOpen={transitionsModalOpen}
                onClose={() => {
                    setTransitionsModalOpen(false);
                }}
                sourceState={stateForTransitions}
                allAvailableStates={allStates}
            />
        </React.Fragment>
    );
};

export default CustomerStatesView;

